import React from 'react';
import { Button, Modal } from 'lmc-ui-library';
import styles from './../../CaseDetailsPage.module.scss';
import { sendDataToPepper, validateData } from '../store/useCases';
import { useDispatch } from 'react-redux';
import { openReview } from 'modules/cm/pages/CaseDetailsPage/Pepper/store/useCases';
import css from 'modules/cm/pages/CaseDetailsPage/Pepper/modalContents/Styles.module.scss';

const Actions: React.FC<any> = ({ isDisabledSendToPepperButton }) => {
  const dispatch = useDispatch();
  const handleSendToPepper = () => {
    dispatch(sendDataToPepper());
  };
  const handleReviewClick = () => {
    dispatch(openReview());
  };

  const handleValidateData = () => {
    dispatch(validateData());
  };

  return (
    <>
      <Modal.Header title="Servicing" className={styles.modalHeader} />
      <Modal.Content className={css.modalContent}>
        <h2>Please select an action</h2>
      </Modal.Content>
      <Modal.Footer style={{ display: 'grid' }}>
        <Button mode="ghost" borderVariant="rectangle" className={styles.actionButton} onClick={handleReviewClick}>
          Review
        </Button>
        <Button mode="ghost" borderVariant="rectangle" className={styles.actionButton} onClick={handleValidateData}>
          Validate data
        </Button>
        <Button
          mode="primary"
          borderVariant="rectangle"
          onClick={handleSendToPepper}
          disabled={isDisabledSendToPepperButton}>
          Upload
        </Button>
      </Modal.Footer>
    </>
  );
};

export default Actions;
